<ng-container>
  <div>
    <eds-panel [hasBorders]="true">
      <div edsFlexbox edsPadding edsPaddingLeft="md" edsPaddingTop="md">
        <ng-container *ngFor="let data of finalRow">
          <ng-container *ngIf="data.colId === 'MULTI_SELECT_CHECKBOX'">
            <eds-checkbox
              [id]="rowData.literatureData?.docId"
              name="story-checkbox"
              [value]="rowData.literatureData?.docId"
              [disabled]="false"
              [checked]="this.rowData.literatureData.isSelected"
              [hideLabel]="true"
              [labelName]="rowData.literatureData?.dctermsTitle"
              [required]="false"
              (checkedChange)="onSelectionChanged($event, rowData)"
            >
            </eds-checkbox>
          </ng-container>
          <ng-container *ngIf="data.colId === 'NAME'">
            <div edsFlexbox flexDirection="column">
              <div class="text-grey1" *ngIf="!isIntel">
                {{
                  "literature." +
                    rowData?.literatureData?.fileExtension +
                    "-format" | translate
                }}
              </div>
              <ft-fund-name-cell-renderer
                [cellRendererData]="rendererData"
              ></ft-fund-name-cell-renderer>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container *ngFor="let data of finalRow">
        <div>
          <eds-panel
            *ngIf="data.colId === 'DETAIL' && !isIntel"
            theme="grey"
            [hasPadding]="true"
          >
            <div edsGrid>
              <div edsRow>
                <div edsCol [columnNumbers]="{ s: 2, m: 2 }">
                  {{ data.label }}
                </div>
                <div *ngIf="data.val" edsCol [columnNumbers]="{ s: 2, m: 2 }">
                  <ft-document-detail
                    [cellRendererData]="rendererData"
                    [convertDateTo]="convertDateTo"
                  ></ft-document-detail>
                </div>
              </div>
            </div>
          </eds-panel>
          <eds-panel
            *ngIf="data.colId === 'PUBLICATION_DATE'"
            edsSpacing="md"
            theme="grey"
            [hasPadding]="true"
          >
            <div edsGrid>
              <div edsRow>
                <div edsCol [columnNumbers]="{ s: 2, m: 2 }">
                  {{ data.label }}:
                </div>
                <div *ngIf="data.val" edsCol [columnNumbers]="{ s: 2, m: 2 }">
                  {{ data.val }}
                </div>
              </div>
            </div>
          </eds-panel>
        </div>
        <ng-container *ngIf="data.colId === 'ACTION'">
          <div edsFlexbox edsPadding edsPaddingLeft="md" edsSpacing="md">
            <ft-document-download [cellRendererData]="rendererData">
            </ft-document-download>
          </div>
        </ng-container>
      </ng-container>
    </eds-panel>
  </div>
</ng-container>
